<template>
  <el-container class="service-order-config-wrap">
    <el-header style="height: auto">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom="0px" :searchList='searchList' v-on:getSearchObj='getSearchObj'></publicExpandSearch>
    </el-header>
    <el-main>
      <div class="table-wrap">
        <el-table :data="orderTableData" :header-cell-style="{
          textAlign: 'center', color: '#333333', fontSize: '14px',
          fontWeight: 'bold', backgroundColor: '#FAFAFA'
        }">
          <el-table-column type="index" label="序号" align="center" fixed="left"></el-table-column>
          <el-table-column prop="orderNo" label="订单编号" width="130" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="serviceName" label="服务名称" width="150" align="center"
            show-overflow-tooltip></el-table-column>
          <el-table-column prop="patientName" label="被服务人" width="120" align="center">
            <template slot-scope="scope">{{ !scope.row.logOff ?
              scope.row.patientName : scope.row.patientName + '(已注销)' }}</template>
          </el-table-column>
          <el-table-column prop="userName" label="下单人" align="center">
          </el-table-column>
          <el-table-column prop="amountOriginal" label="服务价格" align="center">
          </el-table-column>
          <el-table-column prop="payAmount" label="实付金额" align="center">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="165" align="center">
          </el-table-column>
          <el-table-column prop="paymentMethid" label="支付方式" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.paymentMethid | filterPay }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="transactionNo" label="商户订单号" width="150" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="payTime" label="支付时间" width="165" align="center">
          </el-table-column>
          <el-table-column prop="refundUserName" label="退款人" align="center">
          </el-table-column>
          <el-table-column prop="refundMoney" label="退款金额" align="center">
          </el-table-column>
          <el-table-column prop="refundText" label="退款备注" width="150" align="center">
          </el-table-column>
          <el-table-column prop="refundTime" label="退款时间" width="160" align="center">
          </el-table-column>

          <el-table-column prop="paymentState" width="160" label="订单状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.paymentState === 1">待支付</span>
              <span v-if="scope.row.paymentState === 2">已支付</span>
              <span v-if="scope.row.paymentState === 3">已取消</span>
              <span v-if="scope.row.paymentState === 4">已退款</span>
              <span v-if="scope.row.paymentState === 7">已完成</span>
              <span v-if="scope.row.paymentState === 8">待退款</span>
              <!-- <span v-if="scope.row.status === 6">已完成（护士）</span>
            <span v-if="scope.row.status === 7">已完成（患者）</span>
            <span v-if="scope.row.status === 8">已取消（患者取消）</span>
            <span v-if="scope.row.status === 9">已取消（护士取消）</span> -->
            </template>
          </el-table-column>

          <el-table-column prop="status" label="操作" align="center" fixed="right" width="140">

            <template slot-scope="scope">

              <el-button type="text" @click="checkDetail(scope.row)">详情</el-button>
              <el-button type="text" v-if="scope.row.paymentState === 2"
                @click="handleSendOrder(scope.row)">退款</el-button>
              <!-- <span v-if="scope.row.status === 2 || scope.row.status === 9" class="send-order" @click="handleSendOrder(scope.row)">退款</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination style="
          text-align: right;
          background-color: #fff;
          padding-top: 30px;
          padding-bottom: 20px;
        " background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchParams.current" :page-size="searchParams.size"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-main>
    <!-- 派单页面 -->

    <el-dialog title="退款" class="refundDialog" destroy-on-close :visible.sync="showRefund" :close-on-click-modal="false"
      width="30%" center>
      <el-form status-icon label-width="80px" ref="refundRef" :model="cancelReasonData" :rules="cancelReasonFormRules" size="small">
        <el-form-item label="退款金额" prop="refundMoney">
          <el-input v-model="cancelReasonData.refundMoney" placeholder="请输入退款金额"></el-input>
        </el-form-item>
        <el-form-item label="退款说明" prop="refundText">
          <el-input type="textarea" v-model="cancelReasonData.refundText" placeholder="请输入退款说明"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button slot="reference" type="primary" size="small" @click="submitHandel">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="" title="医生上门服务订单详情" style="height: 100%" :visible.sync="dialogVisibleDetails">
      <div class="show-text">
        <ul>
          <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
            <div style="display: flex">
              <li style="margin-right: 10px">
                <p>订单编号:</p>
                <span>{{ detail.orderInfoVO.orderNo }}</span>
              </li>
              <li style="margin-right: 10px">
                <p>服务名称:</p>
                <span>{{ detail.nursingServiceVO.nursingDefinitionName }}</span>
              </li>
            </div>
            <div style="display: flex">
              <li style="margin-right: 10px">
                <p>被服务人:</p>
                <span>{{ detail.orderInfoVO.patientName }}</span>
              </li>
              <li style="margin-right: 10px">
                <p>下单人:</p>
                <span>{{ detail.orderInfoVO.userName }}</span>
              </li>
            </div>
            <div style="display: flex">
              <li style="margin-right: 10px">
                <p>服务价格:</p>
                <span>{{ detail.orderInfoVO.amountOriginal }}</span>
              </li>
              <li style="margin-right: 10px">
                <p>确认时间:</p>
                <span>{{ detail.nursingServiceVO.receiveTime }}</span>
              </li>
            </div>
            <div style="display: flex">
              <li style="margin-right: 10px">
                <p>实付金额:</p>
                <span>{{ detail.orderPayVO.payAmount }}</span>
              </li>
              <li style="margin-right: 10px">
                <p>创建时间:</p>
                <span>{{ detail.orderInfoVO.createTime }}</span>
              </li>
            </div>
            <div style="display: flex">
              <li style="margin-right: 10px">
                <p>支付方式:</p>
                <span>{{ detail.orderPayVO.paymentMethid | filterPay }}</span>
              </li>
              <li style="margin-right: 10px">
                <p>商户订单号:</p>
                <span>{{ detail.orderPayVO.transactionNo ? detail.orderPayVO.transactionNo : '--' }}</span>
              </li>
            </div>
            <div style="display: flex">
              <li style="margin-right: 10px">
                <p>支付时间:</p>
                <span>{{ detail.orderPayVO.payTime }}</span>
              </li>
              <li style="margin-right: 10px">
                <p>结束时间:</p>
                <span>{{ detail.nursingServiceVO.endDateTime }}</span>
              </li>
            </div>
            <div style="display: flex">
              <li style="margin-right: 10px">
                <p>服务时间:</p>
                <span>{{ detail.nursingServiceVO.arrivalTime }} <span
                    v-if="detail.nursingServiceVO && detail.nursingServiceVO.actualEndTime">~</span>{{ detail.nursingServiceVO.actualEndTime }}</span>
              </li>
              <li style="margin-right: 10px">
                <p>退款人:</p>
                <span>{{ detail.orderPayVO.createUserName ? detail.orderPayVO.createUserName : '--' }}</span>
              </li>
            </div>
            <div style="display: flex">
              <li style="margin-right: 10px">
                <p>退款金额:</p>
                <span>{{ detail.orderPayVO.refundMoney ? detail.orderPayVO.refundMoney : '--' }}</span>
              </li>
              <li style="margin-right: 10px">
                <p>退款时间:</p>
                <span>{{ detail.orderPayVO.refundTime ? detail.orderPayVO.refundTime : '--' }}</span>
              </li>
            </div>
            <li style="margin-right: 10px">
              <p>退款备注:</p>
              <span>{{ detail.orderPayVO.refundText ? detail.orderPayVO.refundText : '--' }}</span>
            </li>
            <li style="margin-right: 10px">
              <p>订单状态:</p>
              <span v-if="detail.orderPayVO.paymentState === 1">待支付</span>
              <span v-if="detail.orderPayVO.paymentState === 2">已支付</span>
              <span v-if="detail.orderPayVO.paymentState === 3">已取消</span>
              <span v-if="detail.orderPayVO.paymentState === 4">已退款</span>
              <span v-if="detail.orderPayVO.paymentState === 7">已完成</span>
              <span v-if="detail.orderPayVO.paymentState === 8">待退款</span>
            </li>
          </el-scrollbar>
        </ul>
      </div>
    </el-dialog>
    <!-- <el-dialog
      title="退款"
      width="600px"
      :visible.sync="showCancelReason"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div>
        <el-form ref="cancelReasonForm" label-width="130px" :model="cancelReasonData" :rules="cancelReasonFormRules">
          <el-form-item label="退款说明" prop="cancelReason">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="cancelReasonData.cancelReason"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="text-align:center">
        <el-button type="primary" size="medium" class="btn-bg" @click="handleSaveCancel">确定</el-button>
      </div>
    </el-dialog> -->
  </el-container>
</template>
<script>
// import sendOrderDialog from './sendOrderDialog'
import {
  getDoctorPage,
  getDoctorDetail,
  prescriptionRefund
} from "./api/orderPay.js";

export default {
  components: {
    // sendOrderDialog
  },
  data() {
    var checkMoney = (rule, value, callback) => {
      if (!value || value == 0) {
        return callback(new Error("金额不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value * 100)) {
          callback(new Error("请输入正确的金额"));
        } else {
          if (value > this.selectRow.payAmount) {
            callback(new Error("退款金额不可大于实付金额"));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    return {
      searchParams: {
        current: 1,
        size: 10
      },
      breadList: [{ name: "订单管理" }, { name: "医护上门订单" }],
      searchList: [
        {
          label: "支付",
          paramName: "timeArr",
          inputType: "datetimerange",
          paramstartTime: "payStartTime",
          paramEndTime: "payEndTime",
          showLabel: true,
          isTime: true
        },
        {
          label: "退款",
          paramName: "timeArr1",
          inputType: "datetimerange",
          paramstartTime: "refundStartTime",
          paramEndTime: "refundEndTime",
          showLabel: true,
          isTime: true
        },
        {
          label: "被服务人姓名",
          paramName: "keywords",
          inputType: "input",
          optionData: [],
          remote: false
        }
      ],
      dialogVisibleDetails: false,
      cancelReasonData: {
        cancelReason: ""
      },
      cancelReasonFormRules: {
        refundMoney: [
          { required: true, validator: checkMoney, trigger: "blur" }
        ],
        refundText: [
          { required: true, message: "请输入退款原因", trigger: "blur" }
        ]
      },
      showCancelReason: false,
      selectRow: {},
      showAddQuestion: false,
      patientName: "",
      activeStatus: "2",
      current: 1,
      size: 10,
      total: 0,
      orderTableData: [],
      showRefund: false,
      detail: { orderInfoVO: {}, nursingServiceVO: {}, orderPayVO: {} }
    };
  },

  async created() {
    this.getTableList(1);
  },
  mounted() { },
  methods: {
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.getTableList();
    },
    submitHandel() {
      this.$refs["refundRef"].validate(valid => {
        if (valid) {
          prescriptionRefund({
            ...this.cancelReasonData,
            orderId: this.selectRow.id,
            orderDetailId: this.selectRow.detailId
          }).then(res => {
            if (res.code == 0) {
              this.$message.success("操作成功");
              this.selectRow = {};
              this.$refs["refundRef"].resetFields();
              // this.cancelReasonData = this.$options.data().refund
              this.showRefund = false;
              this.getTableList(1);
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },

    handleClose() {
      this.showCancelReason = false;
    },
    async handleSaveCancel() {
      let valRes;
      this.$refs.cancelReasonForm.validate(val => {
        valRes = val;
      });
      if (!valRes) {
        return;
      }
      let res = await orderCancelled({
        cancelReason: this.cancelReasonData.cancelReason,
        id: this.selectRow.id
      });
      if (res.code === 0) {
        this.$message.success("取消成功");
        this.$refs.cancelReasonForm.resetFields();
        this.getTableList(1);
        this.showCancelReason = false;
      }
    },
    handleSendOrder(row) {
      this.selectRow = row;
      this.showRefund = true;
    },
    checkDetail(row) {
      getDoctorDetail(row.id).then(res => {
        this.detail = res.data;
      });
      this.dialogVisibleDetails = true;
    },
    handleSizeChange(val) {
      this.searchParams.size = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchParams.current = val;
      this.getTableList();
    },
    handleClick() {
      this.getTableList(1);
    },
    async getTableList(flag) {
      this.searchParams.commodityType = "4";
      let res = await getDoctorPage(this.searchParams);
      if (res.code === 0) {
        this.orderTableData = res.data.records;
        this.total = res.data.total;
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-tabs__header {
  margin: 15px 0 0 0;
}

/deep/.el-tabs__nav-wrap::after {
  background-color: #ffffff;
}

.service-order-config-wrap {
  height: 100%;
  width: 100%;

  .active-bg {
    background-color: #fcfcfc;
  }

  .el-header {
    padding-top: 0;
    background: #ffffff;
    text-align: left;
  }

  .menu-name {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 68px;
    text-align: left;
  }

  .tag {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-family: PingFangSC-Medium, PingFang SC;
    margin-bottom: 15px;
    display: flex;
    font-weight: 500;
  }

  .tag::before {
    content: "";
    display: block;
    width: 4px;
    height: 15px;
    background: #1a7bfc;
    margin-right: 15px;
    margin-top: 2.5px;
  }

  .el-aside {
    border-radius: 6px;
    background: #ffffff;
    height: calc(100% - 68px);
    width: 313px;
    margin-right: 16px;
    height: 100%;
    padding: 20px;

    .type-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // height: 46px;
      padding: 0 5px;
      border-radius: 8px;
    }
  }

  .content-form {
    background: #ffffff;
  }

  .add-item {
    // width: 100%;
    background-color: #fcfcfc;
    border: 1px dashed #d9d9d9;
    color: #333333;
    width: 247px;
    height: 35px;
  }

  .add-item-config {
    // width: 100%;
    background-color: #fcfcfc;
    border: 1px dashed #1a7bfc;
    // color: #1A7BFC;
    margin-bottom: 20px;
    width: 247px;
    height: 35px;
    // margin-left:180px;
  }

  .type-name {
    font-size: 14px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    // line-height: 46px;
  }

  .type-option {
    display: flex;
    align-items: center;

    .el-button {
      font-size: 10px;
      font-weight: 400;
      color: #1a7bfc;
      // line-height: 46px;
    }
  }

  .footer-option {
    text-align: left;
    padding-left: 180px;

    .el-button {
      width: 110px;
    }
  }

  /deep/.el-table__header th {
    padding: 0;
    height: 54px;
  }

  .btn-bg {
    background-color: #1a7bfc;
  }

  .el-button--text {
    color: #1a7bfc;
  }

  .line-sepa {
    display: inline-block;
    width: 1px;
    height: 14px;
    background-color: #1a7bfc;
    margin: 0 12px;
  }
}

.send-order {
  color: #1a7bfc;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  font-family: "Microsoft YaHei";
}

.el-table td,
.el-table th {
  padding: 10px 0;
}

.el-button.is-disabled.el-button--text {
  color: #999999;
}

.table-wrap {
  padding: 15px 5px;
  padding-bottom: 0px;
  background-color: #ffffff;
}

.show-text {
  height: 75vh;
  background: #fff;
  padding: 18px;
  padding-right: 8px;
  box-sizing: border-box;
  border-radius: 6px;

  header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    div {
      width: 4px;
      height: 15px;
      background: #1a7bfc;
      margin-right: 12px;
    }

    span {
      font-size: 14px;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
    }
  }

  ul {
    height: 100%;

    li {
      display: flex;
      margin-bottom: 30px;
      width: 50%;

      p {
        width: 72px;
        text-align: left;
        margin-right: 27px;
        font-size: 12px;
        color: #333333;
        line-height: 22px;
      }

      span {
        flex: 1;
        font-size: 12px;
        color: #333333;
        line-height: 22px;
      }
    }
  }
}
</style>
<style lang="less">
.message-del-confirm {
  .el-button--primary {
    background-color: #1a7bfc;
  }
}
</style>
